import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'components/Portal';

import { Button } from 'components/Button';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Client } from 'store/client/actions';
import { docTypeListSelector } from 'store/client/selectors';

const ModalFileUpload = ({ onClose, onClick }) => {
  const dispatch = useDispatch();
  const docTypes = useSelector(docTypeListSelector);
  const handleClick = (data) => {
    return () => {
      onClick(data);
    };
  };

  useEffect(() => {
    dispatch(Client.getDocTypeList());
  }, [dispatch]);

  return (
    <Portal id="modal-upload-file" className="upload-file" onClose={onClose}>
      <div className="modal-upload-file upload-file-form">
        <div className="content-upload-file">
          {' '}
          <b> Выберите тип документа</b>
          <div className="upload-file-buttons">
            {docTypes?.map((elem) => {
              return (
                <Button className="btn-upload-file" onClick={handleClick(elem.docTypeID)} children={elem.docTypeName} />
              );
            })}
          </div>
        </div>
      </div>
    </Portal>
  );
};

ModalFileUpload.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { ModalFileUpload };
